export const LOGINMODUL_USER_INFO_BASIC_REQUEST =
  "LOGINMODUL_USER_INFO_BASIC_REQUEST";
export const LOGINMODUL_USER_INFO_BASIC_SUCCESS =
  "LOGINMODUL_USER_INFO_BASIC_SUCCESS";
export const LOGINMODUL_USER_INFO_BASIC_FAIL =
  "LOGINMODUL_USER_INFO_BASIC_FAIL";
export const LOGINMODUL_USER_INFO_BASIC_RESET =
  "LOGINMODUL_USER_INFO_BASIC_SUCCESS";
